export default __webpack_public_path__ + "static/media/ejjadh-logo.1adedba5.svg";